import React from 'react';
import PropTypes from 'prop-types';
import {
  Tag as StyledTag,
} from './styles';

const Tag = ({
  variant,
  className,
  children,
}) => (
  <StyledTag
    className={className}
    $variant={variant}
  >
    {children}
  </StyledTag>
);

Tag.propTypes = {
  variant: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};
Tag.defaultProps = {
  variant: '',
  className: '',
};

export default Tag;
